<template>
  <b-container>
    <b-row>
      <b-col align="right">
        <b-button variant="primary" @click.stop="modalFormOpenAdd($event.target)" class="mr-1">
          Create
        </b-button>
      </b-col>
    </b-row>

    <b-row class="mt-3">
      <b-col>
        <b-table striped :items="groups" :fields="fields" @row-clicked="rowClickedHandler" :busy="!groupsLoaded">
          <template #table-busy>
            <div class="text-center my-3">
              <b-spinner small /> Loading&hellip;
            </div>
          </template>
          <template #cell(buttons)="row">
            <b-button-group>
              <b-button size="sm" variant="secondary"
                @click.stop="modalFormOpenEdit(row.item, row.index, $event.target)" class="mr-1">
                Edit
              </b-button>
              <b-button size="sm" variant="danger " @click.stop="info(row.item, row.index, $event.target)">
                Remove
              </b-button>
            </b-button-group>
          </template>
        </b-table>
      </b-col>
    </b-row>

    <b-modal id="modalForm" size="xl" @hide="modalFormReset" :title="modalForm.title" ok-variant="primary"
      @ok="createGroup()">
      <b-form v-if="showForm">
        <b-form-input id="id" type="text" v-model="form.ID" hidden></b-form-input>

        <b-form-group id="nameInputGroup" label="Name" label-for="name">
          <b-form-input id="name" type="text" v-model="form.name" autocomplete="off"></b-form-input>
        </b-form-group>

        <b-form-group id="hiddenInputGroup" label="" label-for="hidden">
          <b-form-checkbox id="hidden" v-model="form.hidden" value="true" unchecked-value="">
            Hidden
          </b-form-checkbox>
        </b-form-group>

        <b-form-group label="Lifts" v-if="elevatorsOptions.length > 0">
          <b-input-group class="mb-2">
            <b-form-input v-model="liftFilter" placeholder="Filter lifts..." autocomplete="off"></b-form-input>
            <b-input-group-append v-if="liftFilter">
              <b-button variant="outline-secondary" @click="liftFilter = ''">✕</b-button>
            </b-input-group-append>
          </b-input-group>
          <div class="lift-picker">
            <label v-for="opt in filteredElevatorsOptions" :key="opt.value" class="lift-picker-item"
              :class="{ selected: form.elevators.includes(opt.value) }">
              <input type="checkbox" :value="opt.value" v-model="form.elevators" />
              {{ opt.text }}
            </label>
            <div v-if="filteredElevatorsOptions.length === 0" class="text-muted p-2">No lifts match.</div>
          </div>
          <small class="text-muted">{{ form.elevators.length }} of {{ elevatorsOptions.length }} selected</small>
        </b-form-group>
      </b-form>
    </b-modal>

    <b-modal id="modalInfo" @hide="resetModal" :title="modalInfo.title" ok-variant="danger"
      @ok="removeGroup(modalInfo)">
      <p>{{ modalInfo.content }}</p>
    </b-modal>
  </b-container>
</template>

<script>
import api from './api.js'
import auth from './auth.js'
import moment from 'moment';

export default {
  name: 'groups',
  props: [
    'elevators',
    'groups',
    'groupsLoaded',
  ],
  computed: {
    filteredElevatorsOptions() {
      if (!this.liftFilter) return this.elevatorsOptions;
      const f = this.liftFilter.toLowerCase();
      return this.elevatorsOptions.filter(o => o.text.toLowerCase().includes(f));
    },
    elevatorsOptions() {
      return this.elevators.map(e => {
        return { text: this.elevatorName(e), value: e.id };
      });
    }
  },
  data() {

    return {
      loggedIn: auth.loggedIn(),
      modalInfo: { title: '', content: '', group: null },
      loaded: false,
      showForm: true,
      showAlert: false,
      alertMessage: '',
      modalForm: { title: '' },
      liftFilter: '',
      form: {
        ID: 0,
        name: '',
        hidden: false,
        elevators: [],
      },
      fields: [
        {
          key: 'name',
          sortable: true,
        },
        {
          key: 'elevators',
          label: 'Lifts',
          formatter: (value, key, item) => {
            if (value) {
              return value.length;
            } else {
              return 0;
            }
          }
        },
        {
          key: 'buttons',
          label: '',
          sortable: false,
        },
      ],
    }
  },
  methods: {
    rowClickedHandler(record, index) {
      this.$router.push({ name: 'group', params: { 'id': record.id } })
    },
    createGroup() {
      //evt.preventDefault();
      this.showAlert = false;
      this.alertMessage = '';
      if (this.form.ID != 0) {
        this.form.hidden = !!this.form.hidden
        api.updateGroup(this.form, response => {
          if (response.data == "OK") {
            this.getGroups();
            this.form.name = '';
            this.form.elevators = [];
            this.form.hidden = false;
          } else {
            this.alertMessage = response.data.message;
            this.showAlert = true;
          }
        });
      } else {
        this.form.hidden = !!this.form.hidden
        api.createGroup(this.form, response => {
          if (response.data == "OK") {
            this.getGroups();
            //this.onReset(evt);
          } else {
            this.alertMessage = response.data.message;
            this.showAlert = true;
          }
        });
      }
    },
    onReset(evt) {
      evt.preventDefault();
      this.form.name = '';
      this.form.hidden = false;
      this.showForm = false;
      this.$nextTick(() => { this.showForm = true });
    },
    getGroups() {
      this.$root.$emit('get-groups');
    },
    modalFormOpenAdd(item, index, button) {
      this.modalForm.title = 'Create Group';
      this.form.ID = 0;
      this.form.name = '';
      this.form.hidden = false;
      this.form.elevators = [];
      this.$root.$emit('bv::show::modal', 'modalForm', button);
    },
    modalFormOpenEdit(item, index, button) {
      this.modalForm.title = 'Edit Group';
      this.form.ID = item.id;
      this.form.name = item.name;
      this.form.hidden = !!item.hidden;
      this.form.elevators = [];
      if (item.elevators) {
        item.elevators.forEach(g => {
          this.form.elevators.push(g.id);
        });
      }
      this.$root.$emit('bv::show::modal', 'modalForm', button);
    },
    modalFormReset() {
      this.liftFilter = '';
    },
    info(item, index, button) {
      this.modalInfo.title = `Remove ${item.name}`;
      this.modalInfo.content = `Are you sure you want to remove group ${item.name}?`;
      this.modalInfo.group = item;
      this.$root.$emit('bv::show::modal', 'modalInfo', button);
    },
    resetModal() {
      this.modalInfo.title = '';
      this.modalInfo.content = '';
      this.modalInfo.group = null;
    },
    removeGroup(data) {
      api.deleteGroup(data.group.id, res => {
        this.getGroups();
      })
    },
  },
  created() {
    this.$root.$emit('get-groups');
    this.$root.$emit('get-elevators');
  },
  beforeDestroy() {
  }
}
</script>

<style>
.lift-picker {
  max-height: 240px;
  overflow-y: auto;
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 4px;
}

.lift-picker-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  border-radius: 3px;
  cursor: pointer;
  margin: 0;
  font-weight: normal;
  user-select: none;
}

.lift-picker-item:hover {
  background-color: #f0f4ff;
}

.lift-picker-item.selected {
  background-color: #e8f0fe;
}

.lift-picker-item input[type="checkbox"] {
  margin: 0;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/Groups.vue